<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="用户注册"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-form @submit="onBatchSubmit" ref="activeFormRef">
        <div class="main-info-wrap">
          <div class="main-info-title">个人信息</div>
          <!-- 姓名 -->
          <van-field
              v-model="mainForm.name"
              name="name"
              label="姓名"
              placeholder="请输入姓名"
              required
              trigger="blur"
              :rules="[{ required: true}]"
          />
          <!-- 手机号 -->
          <div class="phone-tip">港澳台手机号必须带对应区号（如+852/+853/+886）</div>
          <van-field
              v-model="mainForm.phone"
              name="phone"
              label="手机号"
              placeholder="请输入手机号"
              type="tel"
              required
              :rules="[{ required: true}, { pattern: mobileReg, message: '请输入合法的手机号' }]"
          />

          <van-field
              readonly
              clickable
              name="address"
              :value="provinceValue"
              label="通讯地址"
              placeholder="点击选择省市区（选填）"
              @click="showArea = true"
          />
          <van-popup v-if="showArea" v-model="mainForm.address" position="bottom">
            <van-area
                :area-list="areaList"
                @confirm="onCityConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <!-- 新增：密码 -->
          <van-field
              v-model="mainForm.password"
              name="password"
              label="密码"
              type="password"
              placeholder="请输入6-16位密码"
              required
              trigger="blur"
              maxlength="16"
              :rules="[
              { required: true },
              { pattern: /^.{6,16}$/, message: '请输入6-16位密码' }
            ]"
          />
          <!-- 新增：确认密码 -->
          <van-field
              v-model="mainForm.confirmPassword"
              name="confirmPassword"
              label="确认密码"
              type="password"
              placeholder="请再次输入密码"
              required
              maxlength="16"
              @blur="checkPwdSame"
              trigger="blur"
              :rules="[{ required: true }]"
          />
        </div>

        <!-- 球杆信息标题 -->
        <div class="cue-info-title">球杆信息（可批量添加）</div>

        <!-- 批量球杆列表：仅保留球杆编号、商品名称 -->
        <div v-for="(item, index) in batchFormList" :key="index" class="batch-item">
          <div class="batch-item-header">
            <span class="header-span">球杆 {{ index + 1 }}</span>
            <van-icon
                name="cross"
                class="delete-icon"
                @click="deleteBatchItem(index)"
                v-if="batchFormList.length > 1"
            />
          </div>

          <!-- 球杆编号 -->
          <van-field
              v-model="item.number"
              name="number"
              label="球杆编码"
              placeholder="请输入球杆编码"
              required
              trigger="blur"
              :rules="[{ required: true }]"
              @blur="registerByNumber(item.number,index)"
          />
          <!-- 商品名称：修正原v-model重复绑定BUG -->
          <van-field
              v-model="item.portalSpecs"
              name="portalSpecs"
              label="商品名称"
              placeholder="请输入商品名称（选填）"
          />
          <van-field
              v-model="item.agentName"
              name="agentName"
              label="代理商"
              placeholder="请输入代理商（选填）"
          />
        </div>

        <!-- 添加新球杆按钮 -->
        <div style="margin: 16px;">
          <van-button
              class="add-item-btn"
              round
              block
              type="default"
              @click="addBatchItem"
          >
            添加新球杆
          </van-button>
        </div>

        <!-- 批量提交按钮 -->
        <div style="margin: 16px;">
          <van-button class="submit-btn" round block type="info" native-type="submit">注册</van-button>
        </div>

      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { Dialog, Toast } from "vant";
import {memberRegister, registerByNumber} from "@/api/sales";
import {areaList} from "@vant/area-data"; // 仅保留核心提交接口

export default {
  data() {
    return {
      provinceValue: '',
      showArea: false,
      areaList,
      // 个人信息表单：仅保留姓名/手机号/地址+新增密码/确认密码
      mainForm: {
        name: '',        // 姓名（必填）
        phone: '',       // 手机号（必填）
        address: '',     // 联系地址（必填）
        password: '',    // 密码（必填，6-16位）
        confirmPassword: '' // 确认密码（必填，和密码一致）
      },
      // mobileReg: /^1[3-9]\d{9}$/, // 仅保留手机号正则
      mobileReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/,

      // 批量球杆列表：仅保留球杆编号、商品名称（核心字段）
      batchFormList: [
        {
          number: '',        // 球杆编号
          portalSpecs: '',    // 商品名称（修正原重复绑定BUG）
          agentName: ''
        }
      ]
    };
  },
  methods: {
    //联系地址弹框确认事件
    onCityConfirm(values){
      this.provinceValue = values
          .filter((item) => !!item)
          .map((item) => item.name)
          .join('/');
      console.log(190,this.provinceValue);
      this.mainForm.address = this.provinceValue;
      this.showArea = false;
    },
    // 新增：确认密码失焦校验 - 和密码一致性校验
    checkPwdSame() {
      const { password, confirmPassword } = this.mainForm;
      if (password && confirmPassword && password !== confirmPassword) {
        Toast("两次输入的密码不一致，请重新输入");
      }
    },

    // 顶部标题栏返回事件：保留核心路由跳转
    onClickLeft() {
      this.$router.push('/app_home');
    },

    // 提示语：保留核心弹窗提示
    showDialogMsg(message) {
      Dialog.alert({
        title: '提示',
        message: message,
      });
    },

    // 添加新的批量球杆条目：精简字段
    addBatchItem() {
      this.batchFormList.push({
        number: '',
        portalSpecs: '',
        agentName: ''
      });
    },

    // 删除批量球杆条目：保留核心删除逻辑
    deleteBatchItem(index) {
      Dialog.confirm({
        title: '提示',
        message: '确认要删除球杆' + (index + 1) + '吗？',
      }).then(() => {
        this.batchFormList.splice(index, 1);
      })
    },

    async registerByNumber(number, index) {
      try {
        const res = await registerByNumber(number);
        if (res.code === 200 && res.data) {
          console.log(237,res);
          this.batchFormList[index].portalSpecs = res.data.portalSpecs || [];
          this.batchFormList[index].agentName = res.data.agentName || [];
        }else{
          this.showDialogMsg(res.returnMsg);
        }
      }catch (error){
        Toast.fail('查询失败，请稍后重试');
      }
    },

    // 球杆激活批量提交：精简所有无用传参，保留核心逻辑
    async onBatchSubmit() {
      try {
        // 1. 先做表单整体校验（所有必填项）
        await this.$refs.activeFormRef.validate();

        // 2. 验证球杆编号唯一性（核心校验保留）
        const numbers = this.batchFormList.map(g => g.number.trim());
        const duplicateNumbers = numbers.filter((num, index) => num && numbers.indexOf(num) !== index);
        if (duplicateNumbers.length > 0) {
          this.showDialogMsg('球杆编码不能重复，请修改后重试');
          return;
        }

        // 3. 验证两次密码一致性
        const { password, confirmPassword } = this.mainForm;
        if (password !== confirmPassword) {
          this.showDialogMsg('两次输入的密码不一致，请重新输入');
          return;
        }

        // 4. 组装提交参数：仅保留核心字段
        const formData = new FormData();
        // 个人信息参数
        formData.append('userName', this.mainForm.name);
        formData.append('phoneNumber', this.mainForm.phone);
        formData.append('address', this.mainForm.address.replaceAll('/','')) || '';
        formData.append('password', this.mainForm.password); // 新增密码参数

        // 批量球杆信息参数：仅球杆编号、商品名称
        this.batchFormList.forEach((item, index) => {
          formData.append(`productList[${index}].number`, item.number);
          formData.append(`productList[${index}].portalSpecs`, item.portalSpecs);
          formData.append(`productList[${index}].agentName`, item.agentName);
        });


        // 5. 调用提交接口
        const res = await memberRegister(formData);
        if (res.code === 200) {
          Toast(res.returnMsg || '注册成功');
          // 提交成功后重置表单
          this.mainForm = { name: '', phone: '', address: '', password: '', confirmPassword: '' };
          this.batchFormList = [{ number: '', portalSpecs: '',agentName: '' }];
          // 跳转登录页
          setTimeout(() => {
            this.$router.push('/app_login');
          }, 1000);
        } else {
          Toast(res.returnMsg || '注册失败，请重试');
        }
      } catch (error) {
        // 捕获表单校验失败提示
        if (error.name === 'ValidateError') {
          Toast('请检查所有必填项是否填写正确');
        } else {
          Toast('提交失败，请稍后重试');
        }
      }
    },
  }
};
</script>

<style scoped lang="scss">
// 保留所有核心样式，无冗余修改
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  margin-bottom: 60px;
  padding: 0 8px;
}
.submit-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
}

// 个人信息区域样式
.main-info-wrap {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin: 15px;

  .main-info-title {
    font-size: 18px;
    font-weight: bold;
    color: #222;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }
  .phone-tip {
    font-size: 12px;
    color: #999;
    margin: 8px 0 4px 0;
    padding-left: 4px;
  }
}

// 球杆信息标题样式
.cue-info-title {
  font-size: 18px;
  font-weight: bold;
  margin: 15px 15px 8px;
}

// 批量球杆样式
.batch-item {
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .delete-icon {
    color: #f56c6c;
    font-size: 16px;
  }
}
.header-span {
  font-size: 16px;
  color: #222;
}
.add-item-btn {
  border: 1px dashed #ccc;
  color: #666;
}

// 适配textarea样式
::v-deep .van-field__control {
  min-height: auto;
}
</style>